import { ButtonHTMLAttributes } from 'react';
import './Button.css';

type ButtonVariant = 'pill' | 'primary';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

function Button({ variant = 'pill', className = '', children, ...rest }: ButtonProps) {
  return (
    <button type="button" className={`btn btn--${variant} ${className}`.trim()} {...rest}>
      {children}
    </button>
  );
}

export default Button;
